export enum EHeaderProfileTypes {
    FULL = 'Image and Text',
    IMAGE = 'only Image',
    TEXT = 'only Text'
}
